import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-410fd2eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "detail-panel-body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { reactive } from 'vue';
import { RegionSimpleVO, SubsidiarySimpleVO } from '../vo';
import Panel from './Panel.vue';
import { gradeColor } from '../constant';
import { hexToRgba } from '@/utils/utilsHandle';
import router from '@/router';
import { params } from '../common';


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    default: 'region',
    type: String,
  },
  year: {
    type: String,
    default: '',
  },
},
  setup(__props, { expose }) {

const props = __props



const state = reactive({
  region: {} as RegionSimpleVO,
  subsidiary: {} as SubsidiarySimpleVO,
  show: false,
  backgroundColor: '',
  color: '',
});

const active = (data: RegionSimpleVO | SubsidiarySimpleVO) => {
  if (props.type === 'region') {
    state.region = data as RegionSimpleVO;
  } else {
    state.subsidiary = data as SubsidiarySimpleVO;
  }
  state.color = gradeColor[data.level];
  state.backgroundColor = hexToRgba(state.color, 0.1);
  state.show = true;
};

const hide = () => {
  state.show = false;
};

const jump = () => {
  params.regionId = state.region.id;
  router.push('/region');
};

expose({
  active,
  hide,
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(Panel, {
    class: "detail-panel",
    style: {"opacity":"0.95","padding":"10px 15px"},
    "background-color": _unref(state).backgroundColor,
    color: _unref(state).color,
    "border-color": _unref(state).color
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: "detail-panel-head",
          style: _normalizeStyle({ borderColor: _unref(state).color })
        }, [
          _createElementVNode("span", null, [
            _createElementVNode("span", null, [
              _createElementVNode("img", {
                style: {"width":"18px","height":"18px","margin-right":"6px","position":"relative","top":"1px"},
                src: 
                require(`@/assets/images/home/grade-${
                  _unref(state).region.level || _unref(state).subsidiary.level
                }.png`)
              
              }, null, 8, _hoisted_1)
            ]),
            _createTextVNode(" 风险定级" + _toDisplayString(_unref(state).region.level || _unref(state).subsidiary.level), 1)
          ]),
          _withDirectives(_createElementVNode("span", {
            class: "jump-button",
            style: _normalizeStyle({ borderColor: _unref(state).color }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (jump()))
          }, " 查看详情 ", 4), [
            [_vShow, __props.type === 'region']
          ])
        ], 4),
        _createElementVNode("div", _hoisted_2, [
          (__props.type === 'region')
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                _createElementVNode("li", null, "高风险模块数量：" + _toDisplayString(_unref(state).region.highRiskModuleCount), 1),
                _createElementVNode("li", null, "高风公司数量：" + _toDisplayString(_unref(state).region.highRiskSubsidiaryCount), 1)
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                _createElementVNode("li", null, "高风险模块数量：" + _toDisplayString(_unref(state).subsidiary.highRiskModuleCount), 1),
                _createElementVNode("li", null, "高风指标数量：" + _toDisplayString(_unref(state).subsidiary.highRiskKriMetricsCount), 1)
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["background-color", "color", "border-color"])), [
    [_vShow, _unref(state).show]
  ])
}
}

})